export default __webpack_public_path__ + "static/media/small_cv_sample3.1934e8bc.png";